export default __webpack_public_path__ + "img/Montserrat-Regular_317b418.ttf";